export default {"src":"/_next/static/media/after-effects.4f10a51c.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};